import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, get, post, ServiceResult } from "@insite/client-framework/Services/ApiService";

const baseUrl = "/api/v1/webuserpreference";

export interface PrintPageParameter extends ApiParameter {
    id: string;
    hideImagesOnPrint: boolean;
}

export interface PrintPageModel {
    hideImagesOnPrint: boolean;
}

export async function getPrintPageUserPreference(id: string): Promise<ServiceResult<PrintPageModel>> {
    const result = await get<PrintPageModel>(`${baseUrl}/${id}`);

    return {
        successful: true,
        result,
    };
}

export async function setPrintPageUserPreference(
    parameter: PrintPageParameter & PrintPageModel,
): Promise<ServiceResult<PrintPageModel>> {
    try {
        const res = await post(`${baseUrl}`, parameter);
        return {
            successful: true,
            result: res,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
                statusCode: error.status,
            };
        }
        throw error;
    }
}
